module.exports = __webpack_public_path__ + "static/media/4.d08445c4.png";